import * as React from 'react';

import { Typography, Button, TextEditor } from '@botco/library';

import { getAttributeChipConfig } from './attributeChipConfig';
import { AttributeTextEditorProps } from './AttributeTextEditor.types';
import { useAttributeTextEditor } from './useAttributeTextEditor';
import { AttributesList } from '../AttributesList';

export const AttributeTextEditor = ({
  onChange,
  initialValue,
  agentId,
  additionalAttributes,
  enabledAttributes,
  ...props
}: AttributeTextEditorProps) => {
  const {
    editor,
    onEditorChange,
    value,
    onAddAttributeClicked,
    onCloseMenu,
    anchorEl,
    onInsertAttribute,
    hiddenDiv,
    target,
    search,
    onKeyDown,
    isInvalidAttributeName,
  } = useAttributeTextEditor({
    onChange,
    initialValue,
  });

  const chipConfig = React.useCallback(
    (chipLabel: string) => getAttributeChipConfig(chipLabel, enabledAttributes),
    [enabledAttributes]
  );

  return (
    <TextEditor.Editor
      {...props}
      editor={editor}
      onChange={onEditorChange}
      value={value}
      onKeyDown={onKeyDown}
      chipConfig={chipConfig}
    >
      <TextEditor.Actions>
        <Button
          data-testid="insert-attribute-button"
          variant="text"
          onClick={onAddAttributeClicked}
        >
          <Typography variant="caption">Add Attribute</Typography>
        </Button>
        <AttributesList
          filter={search}
          agentId={agentId}
          onClose={onCloseMenu}
          enableHover={Boolean(target)}
          anchorEl={target ? hiddenDiv.current : anchorEl}
          onSelect={onInsertAttribute}
          isInvalidAttributeName={isInvalidAttributeName}
          additionalAttributes={additionalAttributes}
        />
        <div
          ref={hiddenDiv}
          style={{
            height: 0,
            width: 0,
            position: 'fixed',
          }}
          data-testid="hidden-div"
        />
      </TextEditor.Actions>
    </TextEditor.Editor>
  );
};
